import { identify, Identify,setUserId,reset  } from '@amplitude/analytics-browser';
import { Profile } from '@staffedupusa/shared-components';

interface UserLocation {
  ip: string | null;
  region: string | null;
  error?: string;
}

export const setUserPropertiesToAmplitude = (
    user: Profile & { sub_users_count: number, enterprise_companies_count: number },
    currentPlanData?: any,
) => {
    const identifyObject = new Identify();
    // reset();
    setUserId(`user-${user.id}`);
    identifyObject.set('email_address', user.email);

    user.company?.id &&
        identifyObject.set('total_team_members', user.sub_users_count);
    identifyObject.set('user_id', user.id);

    identifyObject.set('timezone', user.timezone);

    currentPlanData &&
        currentPlanData?.status === 200 &&
        currentPlanData?.object?.name &&
        identifyObject.set('product_billing_term', currentPlanData?.object?.name);

    user.company?.id && identifyObject.set('companyId', user.company?.id);

    user.enterprise && identifyObject.set('number-of-locations', user?.enterprise_companies_count || 0);

    user.company?.id &&
        identifyObject.set(
            'plan_purchased',
            user.company?.plan == 0
                ? 'Expired'
                : user.company?.plan == 1
                    ? 'Smarter'
                    : user.company?.plan == 2
                        ? 'Pro'
                      : user.company?.plan == 4
                          ? 'Starter'
                        : user.company?.plan == 999
                            ? 'Trial'
                            : user.company?.plan == 3 && 'Enterprise Paid',
        );

    user.company?.id &&
        user.company?.industries &&
        identifyObject.set('Industry', user.company?.industries?.[0]?.name);

    user.company?.id
        ? identifyObject.set(
            'user_role',
            user.master_account ? 'Admin' : 'Sub User',
        )
        : user?.enterprise && identifyObject.set('user_role', 'Enterprise');

    user.company &&
        user.company?.subscription &&
        identifyObject.set(
            'purcahsed_date',
            user.company?.subscription?.date_updated,
        );
    identify(identifyObject);
};


export const getUserRegionAndIP = async (): Promise<UserLocation> => {
  try {
    const getPosition = (): Promise<GeolocationPosition> =>
      new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation is not supported by your browser.'));
        }
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

    const position = await getPosition();
    const { latitude, longitude } = position.coords;

    const getRegionFromPlaces = (): Promise<string | null> =>
      new Promise((resolve, reject) => {
        const map = new google.maps.Map(document.createElement('div'));
        const placesService = new google.maps.places.Places(map);
        const request = {
          location: new google.maps.LatLng(latitude, longitude),
          radius: 1000,
        };

        placesService.nearbySearch(request, (results, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
            const region = results[0].vicinity || results[0].name || null;
            resolve(region);
          } else {
            reject(new Error('Failed to get region from PlacesService.'));
          }
        });
      });

    const region = await getRegionFromPlaces();

    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipResponse.json();

    return {
      ip: ipData.ip,
      region: region || 'Unknown Region',
    };
  } catch (error: any) {
    return { ip: null, region: null, error: error.message };
  }
};
